import React from 'react';
import { Package } from 'lucide-react';
import { ScrollFadeIn } from './ScrollFadeIn';
export function ValueTable() {
  return <section className="py-10 bg-slate-800/30 border-y border-slate-800" data-id="element-629">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-630">
        <ScrollFadeIn data-id="element-631">
          <div className="text-center mb-12" data-id="element-632">
            <Package className="w-10 h-10 text-amber-500 mx-auto mb-4" data-id="element-633" />
            <h2 className="text-3xl md:text-4xl font-serif text-slate-50" data-id="element-634">
              Everything You're Getting Today
            </h2>
          </div>
        </ScrollFadeIn>

        <ScrollFadeIn delay={0.1} data-id="element-635">
          <div className="bg-slate-800 border border-slate-700 rounded-2xl overflow-hidden shadow-2xl" data-id="element-636">
            {/* Row 1 */}
            <div className="flex items-center justify-between px-6 py-5 border-b border-slate-700" data-id="element-637">
              <span className="text-slate-50 font-medium" data-id="element-638">
                The Cortisol Switch (Main eBook)
              </span>
              <span className="text-slate-400 font-medium shrink-0 ml-4" data-id="element-639">
                $37
              </span>
            </div>

            {/* Row 2 */}
            <div className="flex items-center justify-between px-6 py-5 border-b border-slate-700 bg-slate-800/50" data-id="element-640">
              <span className="text-slate-50 font-medium" data-id="element-641">
                Bonus #1: The 3AM Rescue Kit
              </span>
              <span className="text-slate-400 font-medium shrink-0 ml-4" data-id="element-642">
                $37
              </span>
            </div>

            {/* Row 3 */}
            <div className="flex items-center justify-between px-6 py-5 border-b border-slate-700" data-id="element-643">
              <span className="text-slate-50 font-medium" data-id="element-644">
                Bonus #2: Cortisol-Safe Grocery Map
              </span>
              <span className="text-slate-400 font-medium shrink-0 ml-4" data-id="element-645">
                $37
              </span>
            </div>

            {/* Row 4 */}
            <div className="flex items-center justify-between px-6 py-5 border-b border-slate-700 bg-slate-800/50" data-id="element-646">
              <span className="text-slate-50 font-medium" data-id="element-647">
                Bonus #3: The Coffee Exit Plan
              </span>
              <span className="text-slate-400 font-medium shrink-0 ml-4" data-id="element-648">
                $37
              </span>
            </div>

            {/* Total Value */}
            <div className="flex items-center justify-between px-6 py-5 border-b-2 border-amber-500/30 bg-amber-500/5" data-id="element-649">
              <span className="text-amber-400 font-bold uppercase tracking-wide text-sm" data-id="element-650">
                Total Value
              </span>
              <span className="text-amber-400 font-bold text-xl shrink-0 ml-4" data-id="element-651">
                $148
              </span>
            </div>

            {/* Your Price */}
            <div className="flex items-center justify-between px-6 py-8 bg-slate-900" data-id="element-652">
              <span className="text-slate-50 font-bold text-lg" data-id="element-653">
                Your Price Today
              </span>
              <span className="text-emerald-400 font-bold text-4xl shrink-0 ml-4" data-id="element-654">
                $6.39
              </span>
            </div>
          </div>
        </ScrollFadeIn>
      </div>
    </section>;
}